import { config } from '../config';
import {
    isSouthAfricaTenantValue,
    isSouthKoreaTenantValue,
    type Tenant,
} from '../configuration/tokenHandling/tokenSlice';

export const isFleetMonitorVisibleForTenant = (tenant?: Tenant) =>
    !isSouthAfricaTenantValue(tenant) && !isSouthKoreaTenantValue(tenant);

export const isFleetMonitorVisibleForAccount = (account?: string) =>
    !config.vwcoControlTowerAccountId || account !== config.vwcoControlTowerAccountId;
